<template>
  <div :class="['checkbox-input', error && 'error', disabled && 'disabled']">
    <label
      :class="[
        'checkbox-container',
        checkboxType === 'switch' && 'switch',
        checkboxType === 'switch' &&
          value &&
          !intermediateState &&
          'input-checked',
        checkboxType === 'switch' && intermediateState && 'intermediate-state',
      ]"
      :for="id"
    >
      <span v-if="$slots.left" class="label label--left">
        <slot name="left" />
      </span>

      <input
        class="input"
        :id="id"
        type="checkbox"
        :checked="value"
        :disabled="disabled"
        @change="$emit('update:value', $event.target.checked)"
      />

      <div class="indicator" v-if="checkboxType === 'default'">
        <FontIcon class="icon" name="ui_check" v-if="value" />
      </div>

      <span class="label label--right text8">
        <span v-if="label" v-html="label"></span>
        <template v-else-if="$slots.right">
          <slot name="right"> </slot>
        </template>
      </span>
      <span class="slider" v-if="checkboxType === 'switch'">
        <div class="slider__icon">
          <FontIcon
            class="icon"
            name="ui_check"
            v-if="value && !intermediateState"
          />
          <FontIcon class="icon" name="ui_close" v-else />
        </div>
      </span>
    </label>
  </div>
</template>

<style lang="scss">
.checkbox-input {
  margin: rem(0 0 22px);
  width: 100%;
  position: relative;

  &.error {
    @include setColor(--color-status-error);

    * {
      @include setColor(--color-status-error);
    }
  }

  .checkbox-container {
    margin-bottom: 0;
    vertical-align: top;
  }

  .label,
  .indicator {
    display: inline-block;
    vertical-align: middle;
  }

  .label {
    display: block;
    line-height: rem(20px);

    &--left {
      margin-right: rem(30px);
    }

    &--right {
      margin-left: rem(30px);
      font-size: rem(13px);
    }
  }

  .input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .indicator {
    width: rem(20px);
    height: rem(20px);
    border-width: 1px;
    border-style: solid;
    @include setColor(--color-cta, border-color);
    border-radius: rem(4px);
    @include setColor(--color-text-negative);
    cursor: pointer;
    transition: 0.2s background-color;
    position: absolute;
    top: 0;
    left: 0;
  }

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .input:checked ~ .indicator {
    @include setColor(--color-selection, border-color);
    @include setColor(--color-selection, background-color);
  }

  &.disabled {
    opacity: 0.3;
  }

  .switch {
    position: relative;
    display: inline-block;

    .label {
      line-height: rem(25px);
      &--left {
        margin-right: rem(50px);
      }

      &--right {
        margin-left: rem(50px);
      }
    }

    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      @include setColor(--color-selection, background-color);
      @include setColor(--color-selection, color);
      opacity: 0.38;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: rem(12px);
      width: rem(44px);
      height: rem(25px);
    }

    .slider__icon {
      position: absolute;
      height: rem(18px);
      width: rem(18px);
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
      text-align: center;
    }

    &.input-checked,
    &.intermediate-state {
      .slider__icon {
        -webkit-transform: translateX(18px);
        -ms-transform: translateX(18px);
        transform: translateX(18px);
      }
    }

    &.input-checked {
      .slider {
        opacity: 1;
      }
    }
  }
}
</style>

<script>
import FontIcon from "../../FontIcon/FontIcon";

export default {
  components: {
    FontIcon,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    intermediateState: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
    checkboxType: {
      type: String,
      default: "default",
      validator(type) {
        return ["default", "switch"].includes(type);
      },
    },
  },
};
</script>
